/**
 * Server-paged tables (AB#6872).
 *
 * PURE module: no React, MUI, axios or auth imports.
 */

/**
 * Zero-based index of the last page that holds rows: max(0, ceil(count / rowsPerPage) - 1).
 * A missing, negative or non-numeric count, or a page size below 1, gives page 0.
 */
export function lastPageIndex(count: number, rowsPerPage: number): number {
  if (!Number.isFinite(count) || count <= 0) return 0;
  if (!Number.isFinite(rowsPerPage) || rowsPerPage < 1) return 0;
  return Math.max(0, Math.ceil(count / rowsPerPage) - 1);
}
